// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Resource extends TrackingModel {
	public ResourceId: number = 0;
	public PersonId?: number;
	public GenderId?: number;
	public FirstName?: string;
	public MiddleNames?: string;
	public LastName?: string;
	public Suffix?: string;
	public Description?: string;
	public AvatarBlobPath?: string;
}